import React from 'react';
import classnames from 'classnames';

import styles from './StickyButtonFooter.module.scss';

export default function StickyButtonFooter({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={classnames([styles.StickyMobileFooter, className])}>
      {children}
    </div>
  );
}
